import PlayerModel from './PlayerModel'

export default (challenge) => {
  if (!challenge) return

  if (challenge.players && challenge.players.length) {
    challenge.players = challenge.players.map(player => PlayerModel(player))
  }

  return Object.defineProperties(challenge, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/ChallengeModel.js